import { Injectable } from '@angular/core';
import {PaymentService} from "./payments/payment.service";
import {PrivilegeService} from "./privilege.service";
import {Observable, of} from "rxjs";
import {AppAuthorities} from "../enums/app-authorities";
import {catchError, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class PaymentConfigurationResolverService {

  constructor(private paymentService: PaymentService, private privilegeService: PrivilegeService) {}

  resolve(): Observable<boolean> {
    if (!this.privilegeService.isAuthorized(AppAuthorities.PAYMENT_PROCESS_PAYMENT_REQUEST_UPLOAD)) {
      return of(false);
    }

    return this.paymentService.getSavedConfiguration().pipe(
      map((response: any) => {
        const data = response.body;
        const hasFieldMapping = Array.isArray(data.fieldMapping) && data.fieldMapping.length > 0;
        const hasFilePreview = data.filePreviewData && Object.keys(data.filePreviewData).length > 0;
        return hasFieldMapping || hasFilePreview;
      }),
      catchError(err => {
        return of(true);
      })
    );
  }
}
